import { render, staticRenderFns } from "./BaixaManual.vue?vue&type=template&id=16c15ad1&scoped=true"
import script from "./BaixaManual.vue?vue&type=script&lang=js"
export * from "./BaixaManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c15ad1",
  null
  
)

export default component.exports